import { ventesFr, ventesEn } from './i18nVentesAddons.js';
import { frIa, enIa } from './i18nIa.js';
import { frAddons, enAddons } from './i18nAddons.js';
import { frAppsMobiles, enAppsMobiles } from './i18nAppsMobiles.js';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { enEspaces, frEspaces } from './i18nEspaces.js';
import {
  actionsJournalEn,
  actionsJournalFr,
  champsJournalEn,
  champsJournalFr,
} from './i18nJournal.js';
import { enDemandesOuverture, frDemandesOuverture } from './i18nDemandesOuverture.js';
import { enDemandesSite, frDemandesSite } from './i18nDemandesSite.js';
import { enDiagnosticsIos, frDiagnosticsIos } from './i18nDiagnosticsIos.js';
import { enOuvertures, frOuvertures } from './i18nOuvertures.js';
import { enConnecteur, frConnecteur } from './i18nConnecteur.js';
import { enCorrespondance, frCorrespondance } from './i18nCorrespondance.js';
import { enImages, frImages } from './i18nImages.js';
import { enPlan, frPlan } from './i18nPlan.js';
import { enReprise, frReprise } from './i18nReprise.js';
import { enSaisies, frSaisies } from './i18nSaisies.js';
import { comptabiliteEn, comptabiliteFr } from './pages/Comptabilite/libelles.js';
import { vueDAigleEn, vueDAigleFr } from './pages/VueDAigle/libelles.js';

/**
 * Français d'abord, anglais ensuite (D15). Namespace unique `console` : c'est
 * la console Artosera (Venio), pas la régie — aucun texte partagé avec elle.
 * Voix 2.2 : phrases courtes, jamais « dashboard », « SaaS », « upload ».
 */
const fr = {
  ia: frIa,
  addons: frAddons,
  ventes: ventesFr,
  appsMobiles: frAppsMobiles,
  ...frSaisies,
  ...frOuvertures,
  ...frDemandesSite,
  ...frDemandesOuverture,
  ...frDiagnosticsIos,
  ...frReprise,
  ...frCorrespondance,
  ...frConnecteur,
  ...frImages,
  plan: frPlan,
  ...frEspaces,
  connecteurs: {
    sso: {
      resume: 'Connexion unique : {{identites}}, {{sessions}}, dernière connexion {{date}}.',
      identites_one: '{{count}} identité liée',
      identites_other: '{{count}} identités liées',
      sessions_one: '{{count}} session ouverte',
      sessions_other: '{{count}} sessions ouvertes',
      jamais: 'jamais',
      inactif: 'La connexion unique est désactivée.',
      erreur: 'Impossible de lire l’état de la connexion unique.',
    },
    titre: 'Connecteurs',
    erreur: 'Impossible de lire les connecteurs.',
    simulation: 'Plateforme en mode simulé : aucun service tiers n’est appelé.',
    reel: 'Plateforme en mode réel.',
    colonnes: {
      connecteur: 'Connecteur',
      module: 'Module',
      etat: 'État',
      secret: 'Secret',
      verifie: 'Vérifié le',
    },
    noms: {
      brevo: 'Brevo (newsletter)',
      artsy: 'Artsy',
      artnet: 'Artnet',
      stripe: 'Stripe (paiement)',
      oidc: 'Fournisseur d’identité (OIDC)',
    },
    moduleActif: 'Module activé',
    moduleInactif: 'Module non activé',
    modes: { simule: 'Configuré (simulé)', reel: 'Configuré' },
    etats: { nonConfigure: 'Non configuré', erreur: 'Erreur : {{code}}' },
  },

  marque: {
    console: 'Console Artosera',
    titre: 'Exploitation de la plateforme',
    piedDePage: 'Artosera — la console',
  },
  nav: {
    aria: 'Navigation de la console',
    vueDAigle: 'Vue d’aigle',
    comptabilite: 'Comptabilité',
    finances: 'Finances',
    jalons: 'Jalons',
    associes: 'Associés',
    galeries: 'Galeries',
    ouvertures: 'Ouvertures',
    demandes: 'Demandes',
    demandesSite: 'Demandes de site',
    diagnosticsIos: 'Plantages de l’app',
    profils: 'Profils de reprise',
    travaux: 'Travaux',
    journal: 'Journal',
    sante: 'Santé',
    paliers: 'Paliers',
    appsMobiles: 'Apps mobiles',
    interrupteurs: 'Interrupteurs globaux',
    securite: 'Sécurité',
    ouvrirMenu: 'Ouvrir la navigation',
    fermerMenu: 'Fermer la navigation',
  },
  roles: {
    associe: 'Associé',
    support: 'Support',
    exploitation: 'Exploitation',
    direction: 'Direction',
    inconnu: 'Rôle inconnu',
  },
  session: {
    verification: 'Vérification de la session…',
    seDeconnecter: 'Se déconnecter',
    accesRefuseTitre: 'Accès réservé à Venio',
    accesRefuseTexte:
      'Ce compte n’a pas de rôle sur la console Artosera. Contactez la direction de Venio.',
    reserveDirection: 'Cette page est réservée à la direction de Venio.',
    pasOuverte: 'Cette page n’est pas ouverte à votre rôle.',
    titreDocument: '{{page}} — Console Artosera',
  },
  securite: {
    titre: 'Sécurité du compte',
    sousTitre: 'La double authentification protège l’accès à la console.',
    confine:
      'La double authentification est obligatoire pour ce compte. Configurez-la pour continuer : la console reste fermée d’ici là.',
    grace:
      'La double authentification est obligatoire pour ce compte. Configurez-la dès maintenant.',
    statutActif: 'Double authentification active',
    statutInactif: 'Double authentification non configurée',
    demarrer: 'Configurer la double authentification',
    etape1Titre: '1. Ajoutez le compte à votre application',
    etape1Texte:
      'Scannez ce code avec une application d’authentification (par exemple celle de votre téléphone).',
    qrAlt: 'Code QR à scanner avec votre application d’authentification',
    cleManuelle: 'Ou saisissez cette clé à la main :',
    etape2Titre: '2. Saisissez le code affiché',
    champCode: 'Code à six chiffres',
    confirmer: 'Activer',
    annuler: 'Annuler',
    codesTitre: 'Vos codes de secours',
    codesTexte:
      'Chaque code sert une seule fois, si vous n’avez plus votre téléphone. Notez-les en lieu sûr : ils ne seront plus affichés.',
    codesListe: 'Codes de secours',
    continuer: 'J’ai noté mes codes, continuer',
    regenererTitre: 'Codes de secours',
    regenererTexte:
      'De nouveaux codes remplacent les anciens. Saisissez un code de votre application, jamais un code de secours.',
    regenerer: 'Générer de nouveaux codes',
    termine: 'Terminé',
    erreurCode: 'Code refusé. Vérifiez l’heure de votre téléphone et réessayez.',
    erreurGenerique: 'L’opération n’a pas abouti. Réessayez.',
  },
  connexion: {
    titre: 'Console Artosera',
    sousTitre: 'Réservée aux comptes Venio.',
    champEmail: 'Adresse e-mail',
    champMotDePasse: 'Mot de passe',
    bouton: 'Se connecter',
    enCours: 'Connexion…',
    erreurGenerique: 'La connexion a échoué. Réessayez.',
    erreurIdentifiants: 'Identifiants invalides.',
    erreurVerrouille:
      'Ce compte est verrouillé après plusieurs échecs. Réessayez dans quelques minutes.',
    erreurDesactive: 'Ce compte est désactivé. Contactez la direction de Venio.',
    titreOnglet: 'Connexion',
    deuxiemeFacteurTitre: 'Double authentification',
    deuxiemeFacteurTexte: 'Saisissez le code de votre application d’authentification.',
    champCodeTotp: 'Code à six chiffres',
    champCodeSecours: 'Code de secours',
    utiliserCodeSecours: 'Utiliser un code de secours à la place',
    utiliserTotp: 'Utiliser le code de l’application à la place',
    valider: 'Valider',
  },
  galeries: {
    titre: 'Galeries',
    texte: 'Toutes les galeries hébergées par Artosera.',
    nouvelleGalerie: 'Nouvelle galerie',
    rechercheLabel: 'Rechercher une galerie',
    recherchePlaceholder: 'Nom ou identifiant…',
    filtreEtatLabel: 'État',
    filtrePalierLabel: 'Palier',
    tousEtats: 'Tous les états',
    tousPaliers: 'Tous les paliers',
    etat: {
      active: 'Active',
      suspendue: 'Suspendue',
      resiliee: 'Résiliée',
      purge_en_cours: 'Purge en cours',
      purgee: 'Purgée',
    },
    palier: { essentiel: 'Essentiel', galerie: 'Galerie', groupe: 'Groupe' },
    colonnes: {
      nom: 'Galerie',
      palier: 'Palier',
      etat: 'État',
      addons: 'Add-ons',
      modules: 'Modules',
      connecteurs: 'Connecteurs',
      domaines: 'Domaines',
      membres: 'Membres',
      dernierePublication: 'Dernière publication',
      derniereSauvegarde: 'Dernière sauvegarde',
    },
    jamais: 'Jamais',
    coeurSeul: 'Cœur seul',
    vide: 'Aucune galerie ne correspond à ces filtres.',
  },
  fiche: {
    retour: 'Retour aux galeries',
    introuvable: 'Cette galerie est introuvable.',
    creeLe: 'Créée le {{date}}',
    onglets: {
      identite: 'Identité et palier',
      addons: 'Add-ons',
      modules: 'Modules',
      theme: 'Thème de la régie',
      connecteurs: 'Connecteurs',
      domaines: 'Domaines',
      membres: 'Membres',
      sauvegardes: 'Sauvegardes et exports',
      reprise: 'Reprise',
      travaux: 'Travaux',
      journal: 'Journal',
      support: 'Accès de support',
      resiliation: 'Résiliation',
    },
    identite: {
      titre: 'Identité et palier',
      champPalier: 'Palier',
      champEtat: 'État',
      groupe: 'Groupe',
      aucunGroupe: 'Aucun groupe',
      palierAide:
        'Le palier est une donnée commerciale : il règle les quotas, jamais les modules. Ils se règlent dans l’onglet Modules.',
      lienModules: 'Régler les modules',
      quotasTitre: 'Quotas',
      stockage: 'Stockage',
      stockageIndisponible: 'Mesure non disponible pour l’instant · quota {{quota}}',
      stockageMesure: '{{utilise}} sur {{quota}} · {{objets}} objets · mesuré le {{mesureLe}}',
      membresMax: 'Membres autorisés',
      illimite: 'Illimité',
      enregistrer: 'Enregistrer',
      enCours: 'Enregistrement…',
      succes: 'Fiche mise à jour.',
    },
    theme: {
      titre: 'Thème de la régie',
      texte:
        'Le design de la régie de cette galerie : navigation, typographie et palette. Le mode clair ou sombre et le mode foire restent au choix de chaque utilisateur.',
      choixClient: 'Laisser le client choisir son thème',
      choixClientAide:
        'Coupé : la régie applique ce thème et n’affiche aucun sélecteur de design. Activé : chaque utilisateur choisit son design, et ce thème reste celui par défaut.',
      lectureSeule: 'Lecture seule : votre rôle ne permet pas de régler le thème.',
      resiliee: 'Cette galerie est résiliée : son thème ne se règle plus.',
      enregistrer: 'Enregistrer',
      enCours: 'Enregistrement…',
      succes: 'Thème de la régie mis à jour.',
      erreur: 'Le thème n’a pas pu être enregistré. Réessayez.',
      fermer: 'Fermer',
      descriptions: {
        halo: 'Surfaces douces, navigation latérale et priorités en clair.',
        structure: 'Navigation horizontale, listes de travail et inspecteur précis.',
        collection: 'Inventaire visuel, bandeau contrasté et œuvres au premier plan.',
        brut: 'Papier kraft, orange signal, filets épais et ombres franches.',
        atelier: 'Composition éditoriale, palette minérale et espace de travail latéral.',
        aurore: 'Lumière ambiante, verre dépoli et navigation en pilule flottante.',
        monolithe: 'Espace, filets fins, accent champagne et navigation latérale sobre.',
        blanc: 'Mur blanc chaud, graphite et œuvres accrochées dans un espace calme.',
        spatial: 'Verre neutre, profondeur douce et rail latéral flottant.',
        chrome: 'Métal satiné, typographie étendue et sélecteur horizontal irisé.',
        'liquid-glass':
          'Verre liquide : barres flottantes translucides, reflets de bord et œuvres nettes au premier plan.',
        'verre-de-jour':
          'Salle de jour : capsules de verre clair, halos tirés des œuvres et accent mauve doux.',
        'verre-de-nuit':
          'Verre de nuit : îlots de verre sombres, lueurs violettes et capsule de navigation flottante.',
      },
    },
    modules: {
      titreCoeur: 'Cœur',
      texteCoeur: 'Toujours actifs, pour toutes les galeries. Ils ne se désactivent pas.',
      inclus: 'Inclus',
      titreComplementaires: 'Modules complémentaires',
      texteComplementaires:
        'Vendus en option, désactivés par défaut. Désactiver un module ne supprime aucune donnée.',
      titreServices: 'Services',
      texteServices:
        'Le site public et la boutique, vendus comme des services. Désactivés par défaut ; coupés, aucune route publique ne répond.',
      lectureSeule: 'Lecture seule : votre rôle ne permet pas de régler les modules.',
      resiliee: 'Cette galerie est résiliée : ses modules ne se règlent plus.',
      etat: {
        actif: 'Actif',
        inactif: 'Inactif',
        coupe: 'Coupé pour toutes les galeries',
        bientot: 'Bientôt disponible',
        enAttente: 'En attente d’un module requis',
      },
      necessite: 'Nécessite {{liste}}',
      dependants_one: '{{liste}} en dépend',
      dependants_other: '{{liste}} en dépendent',
      activerDabord: 'Activez d’abord {{liste}}.',
      eteint: 'Activé, mais éteint tant que {{liste}} manque.',
      coupeTexte:
        'Coupé pour toutes les galeries. Il reviendra quand la direction de Venio le rétablira.',
      bientotTexte: 'Pas encore livré : il ne peut pas être activé.',
      succesActive: '{{module}} activé.',
      succesDesactive: '{{module}} désactivé. Les données sont conservées.',
      desactiverTitre: 'Désactiver {{module}} ?',
      desactiverTexte:
        'Les données sont conservées. Elles reviendront telles quelles à la réactivation.',
      desactiverVentes:
        'Les factures et avoirs déjà émis restent consultables : la loi impose de les conserver dix ans.',
      desactiverSite:
        'Formulaires, inscriptions et publications s’arrêtent, et le site publié est retiré. Ses pages, ses réglages et ses versions sont conservés : la réactivation le republie.',
      desactiverDependants: 'Ces modules en dépendent et s’éteindront aussi : {{liste}}.',
      desactiver: 'Désactiver',
      annuler: 'Annuler',
      fermer: 'Fermer',
      enCours: 'Enregistrement…',
      erreurChargement: 'Impossible de charger les modules de cette galerie.',
      erreurs: {
        module_coeur: 'Ce module fait partie du cœur : il ne se désactive pas.',
        module_non_disponible: 'Ce module n’est pas encore livré : il ne peut pas être activé.',
        dependances_manquantes: 'Activez d’abord {{liste}}.',
        galerie_resiliee: 'Cette galerie est résiliée : ses modules ne se règlent plus.',
        revision_modules_perimee:
          'Les modules de cette galerie ont changé entre-temps. Rechargez la page, puis recommencez.',
        journal_indisponible:
          'Le journal n’a pas pu être écrit : rien n’a été changé. Réessayez dans un instant.',
        generique: 'Le changement n’a pas abouti. Réessayez.',
      },
    },
    domaines: {
      titre: 'Domaines',
      hote: 'Hôte',
      dns: 'Enregistrement à poser',
      etat: 'État',
      verifieLe: 'Vérifié le',
      jamaisVerifie: 'Jamais vérifié',
      verifier: 'Vérifier',
      retirer: 'Retirer',
      principal: 'Principal',
      rendrePrincipal: 'Rendre principal',
      actions: 'Actions',
      servi: 'Servi par Artosera',
      consigneCname: 'CNAME → {{valeur}}',
      consigneA: 'A → {{valeurs}}',
      consigneAaaa: 'AAAA → {{valeurs}}',
      consigneANonConfiguree: 'A → adresse du serveur non configurée : contactez l’exploitant',
      sansAaaa: 'Aucun enregistrement AAAA',
      aidePrincipal:
        'Le domaine principal est l’adresse de la galerie : ses autres domaines actifs et son sous-domaine Artosera y redirigent.',
      ajouter: 'Ajouter un domaine',
      champHote: 'Nom d’hôte',
      dialogueTitre: 'Ajouter un domaine',
      dialogueTexte:
        'Le domaine est ajouté à vérifier. Un sous-domaine (www…) pointe un CNAME vers le sous-domaine Artosera de la galerie ; un domaine nu, qui ne peut pas porter de CNAME, suit les adresses du serveur indiquées sur la fiche. Suivez les consignes DNS de la fiche : A pour les IPv4, AAAA uniquement pour les IPv6 attendues.',
      annuler: 'Annuler',
      fermer: 'Fermer',
      vide: 'Aucun domaine.',
      etatValeur: { a_verifier: 'À vérifier', actif: 'Actif', desactive: 'Désactivé' },
      retrait: {
        titre: 'Retirer ce domaine ?',
        texte:
          '{{hote}} ne servira plus la galerie ni son site : les visiteurs qui l’utilisent n’y arriveront plus. La ligne reste dans la liste, en « Désactivé », pour garder l’historique.',
        garder: 'Garder le domaine',
        confirmer: 'Retirer le domaine',
        enCours: 'Retrait…',
      },
      erreurs: {
        hote_invalide:
          'Ce nom d’hôte n’est pas valide. Utilisez des lettres, des chiffres et des tirets séparés par des points, par exemple www.ma-galerie.fr.',
        sous_domaine_plateforme:
          '{{hote}} appartient à la plateforme : un sous-domaine de {{suffixe}} ne peut pas servir de domaine personnalisé.',
        cname_absent: '{{hote}} : aucun CNAME trouvé. Attendu : {{attendu}}.',
        cname_incorrect: '{{hote}} : le CNAME pointe ailleurs. Attendu : {{attendu}}.',
        a_absent: '{{hote}} : aucun enregistrement A trouvé. Attendu : {{attendu}}.',
        a_incorrect:
          '{{hote}} : tous les enregistrements A doivent pointer vers {{attendu}} ; retirez ceux de l’ancien hébergeur.',
        aaaa_present:
          '{{hote}} : supprimez l’enregistrement AAAA. Le serveur n’a pas d’IPv6 : le certificat et les visiteurs en IPv6 échoueraient.',
        aaaa_incorrect: '{{hote}} : les enregistrements AAAA doivent pointer vers {{attendu}}.',
        aaaa_indetermine:
          '{{hote}} : impossible de savoir s’il existe un enregistrement AAAA. Réessayez dans un instant.',
        domaine_nu_non_configure:
          'La vérification des domaines nus n’est pas configurée sur ce serveur : contactez l’exploitant.',
        domaine_non_actif: '{{hote}} : seul un domaine actif peut devenir principal.',
        suffixe_public: '{{hote}} est un suffixe public : aucune galerie ne peut le posséder.',
        domaine_deja_pris: '{{hote}} est déjà rattaché à une autre galerie.',
        domaine_par_defaut: 'Le sous-domaine par défaut est posé au provisionnement.',
        generique: '{{hote}} : l’opération n’a pas abouti. Réessayez.',
      },
    },
    membres: {
      titre: 'Membres',
      email: 'E-mail',
      droits: 'Droits fins',
      aucunDroit: 'Aucun',
      droit: {
        voirPrixArtiste: 'Voir le prix artiste',
        coffreConfidentiel: 'Ouvrir le coffre confidentiel',
        emettreFactures: 'Émettre des factures',
        publierSite: 'Publier le site',
      },
      role: 'Rôle',
      dernierAcces: 'Dernier accès',
      jamaisConnecte: 'Jamais connecté',
      vide: 'Aucun membre.',
    },
    sauvegardes: {
      titre: 'Sauvegardes',
      date: 'Date',
      taille: 'Taille',
      etat: 'Résultat',
      vide: 'Aucune sauvegarde enregistrée pour l’instant.',
      lancerTest: 'Lancer une restauration de test',
      enCoursTest: 'Lancement…',
      succesTest: 'Restauration de test lancée : suivez son avancement dans Travaux.',
      etatValeur: { reussie: 'Réussie', echouee: 'Échouée', en_cours: 'En cours' },
      exportsTitre: 'Exports',
      demander: 'Demander un export',
      enCoursExport: 'Demande…',
      succesExport: 'Export demandé : suivez son avancement dans Travaux.',
      demandeLe: 'Demandé le',
      pretLe: 'Déposé le',
      expireLe: 'Lien valable jusqu’au',
      enPreparation: 'En préparation',
      videExports: 'Aucun export demandé.',
      exportEtat: 'État',
      exportTaille: 'Taille',
      exportFinal: 'export final',
      exportEmpreinte: 'Empreinte SHA-256',
      exportActions: 'Actions',
      exportOrigine: {
        console: 'Console',
        mensuel: 'Copie mensuelle',
        resiliation: 'Résiliation',
      },
      exportEtatValeur: {
        en_attente: 'En attente',
        en_cours: 'En cours',
        verification: 'Vérification du gel',
        pret: 'Prêt',
        incomplet: 'Incomplet',
        echoue: 'Échec',
        manquant: 'Archive introuvable',
        supprime: 'Éliminé',
      },
      verificationAide:
        'L’archive attend la fin d’une fenêtre de calme de dix minutes, pour prouver que plus rien n’écrit dans la galerie (plus longtemps si elle est encore écrite). Le courriel à la direction part ensuite.',
      lienExpire: 'Lien expiré',
      envoyeLe: 'Envoyé le {{date}}',
      telechargeLe: 'Téléchargé par la galerie le {{date}}, réception non accusée',
      accuseLe: 'Réception accusée le {{date}}',
      renvoyer: 'Renvoyer à la direction',
      renvoye:
        'Archive renvoyée à {{transmis}} membre(s) de la direction, lien valable jusqu’au {{date}}.',
      consoleSansAcces:
        'La console ne télécharge pas les archives : elles ne vont qu’à la direction de la galerie.',
    },
    support: {
      titre: 'Accès de support',
      texte:
        'Aucun accès aux données métier d’une galerie sans autorisation de sa direction, limitée à 24 h et journalisée.',
      actif: 'Accès accordé',
      enAttente: 'Demande en attente d’accord par la direction de la galerie',
      inactif: 'Aucun accès de support en cours.',
      refusInfo:
        'Refuser une demande se fait depuis la galerie, pas depuis la console. Un refus reste visible dans le Journal de cette galerie.',
      expireLe: 'Expire le {{date}}',
      champMotif: 'Motif',
      champRole: 'Droits demandés',
      roles: {
        lecture: 'Lecture seule',
        equipe: 'Équipe',
      },
      aideRoles: {
        lecture: 'Consulter et dépanner, sans rien modifier.',
        equipe:
          'Réaliser, régler et publier le site, ou corriger des données. La direction voit ce choix avant d’accorder.',
      },
      demander: 'Demander un accès',
      enCoursDemande: 'Demande…',
      succesDemande: 'Accès demandé. La direction de la galerie doit l’accorder.',
      revoquer: 'Mettre fin à l’accès',
      enCoursRevocation: 'Fin de l’accès…',
      succesRevocation: 'Accès de support terminé.',
    },
    resiliation: {
      titre: 'Résiliation',
      avertissement:
        'La résiliation prépare un export complet et envoie son lien à la direction. Rien n’est effacé de soi-même : les données restent récupérables 90 jours ; ensuite, la direction de Venio lance la purge (base, stockage, site publié), une fois que la galerie a accusé réception de l’export ; les sauvegardes ont une rétention distincte de 90 jours et leur effacement complet doit être contrôlé. Une purge historique déjà partielle reste fermée à la récupération et ses données effacées ne sont pas restaurées.',
      champConfirmation: 'Identifiant de la galerie, pour confirmer',
      aide: 'Saisissez « {{slug}} » pour activer la résiliation.',
      bouton: 'Résilier la galerie',
      enCours: 'Résiliation…',
      succes:
        'Résiliation lancée : export en préparation. La purge se lancera à la main, dans 90 jours au plus tôt.',
      dejaResiliee: 'Cette galerie est déjà résiliée.',
      purgeTitre: 'Purge',
      resilieeLe: 'Résiliée le {{date}}.',
      purgePossible: 'Purge possible à partir du {{date}} ; rien ne se purge de soi-même.',
      accuseLe: 'Réception de l’export final accusée le {{date}}.',
      sansAccuse: 'Aucun membre de la direction n’a encore accusé réception de l’export final.',
      demandeeLe: 'Purge lancée le {{date}} par {{par}}.',
      purgeEnCours: 'Purge en cours depuis le {{date}} : la galerie n’accueille plus rien.',
      purgeeLe:
        'Purgée le {{date}} : base, stockage (toutes versions), site et sauvegardes propres à la galerie effacés.',
      effacementPrevu:
        'Effacement complet prévu le {{date}}, à l’expiration des sauvegardes communes qui la portent encore.',
      effacementComplet:
        'Effacement complet constaté le {{date}} : plus aucune sauvegarde ne la porte.',
      purgeForcee: 'Purge lancée sans accusé de réception. Motif : {{motif}}',
      lancerTitre: 'Lancer la purge',
      lancerTexte:
        'Réservé à la direction de Venio. La purge efface la base, le stockage et le site publié ; elle est irréversible.',
      delaiEnCours:
        'Le délai de 90 jours court jusqu’au {{date}} : la purge ne peut pas encore être lancée.',
      forcerTexte:
        'Sans accusé de réception, la purge exige un motif écrit : il est journalisé et visible par la galerie.',
      champMotif: 'Motif écrit',
      aideMotif: 'Quinze caractères au moins : la demande de la galerie, sa référence.',
      lancerBouton: 'Lancer la purge',
      reprendreBouton: 'Reprendre la purge',
      lancerSucces: 'Purge lancée.',
      operationsEnCours_one:
        '{{count}} opération en cours sur la galerie : la purge l’attend, elle ne l’interrompt jamais.',
      operationsEnCours_other:
        '{{count}} opérations en cours sur la galerie : la purge les attend, elle ne les interrompt jamais.',
      remiseTitre: 'Remettre le compteur à zéro',
      remiseTexte:
        'Seulement si une panne a laissé le compteur bloqué : la remise est refusée tant qu’un travail de la galerie tourne. Attention : un téléchargement encore en cours ne sera plus compté, et la purge qui suivra le coupera. Le motif est journalisé.',
      champMotifRemise: 'Motif de la remise à zéro',
      remiseBouton: 'Remettre à zéro',
      remiseSucces: 'Compteur remis à zéro.',
      repriseRequise:
        'Reprise supervisée requise : cette purge a commencé sous un protocole antérieur, et son contrôle a échoué ({{raison}}). La barrière reste posée ; rien ne dit ce qui a déjà été effacé.',
      repriseTitre: 'Reprendre la purge (supervisée)',
      repriseTexte:
        'Réservé à la direction de Venio, après avoir constaté l’état réel de la galerie (base, stockage, sites). La reprise pose la validation à votre nom et mène la purge au bout : elle est irréversible. Le motif est journalisé.',
      champMotifReprise: 'Motif de la reprise',
      repriseBouton: 'Reprendre la purge',
      repriseSucces: 'Purge reprise sous supervision.',
      historiqueInconnu:
        'Historique des dépôts de sauvegarde inconnu : l’effacement complet ne sera pas constaté tant qu’il n’est pas vérifié.',
      historiqueTitre: 'Historique des dépôts vérifié',
      historiqueTexte:
        'Listez TOUS les dépôts de sauvegarde qui ont pu recevoir des données de cette galerie, y compris ceux qui ne sont plus configurés. Chacun devra ensuite être configuré et contrôlé. Le motif est journalisé.',
      champDepots: 'Dépôts de sauvegarde, un par ligne',
      aideDepots_one: '{{count}} dépôt saisi (par exemple s3:https://point-d-acces/bucket).',
      aideDepots_other: '{{count}} dépôts saisis (par exemple s3:https://point-d-acces/bucket).',
      champMotifHistorique: 'Motif de la vérification',
      historiqueBouton: 'Déclarer l’historique vérifié',
      historiqueSucces: 'Historique des dépôts déclaré vérifié.',
    },
  },
  travaux: {
    titre: 'Travaux',
    texte: 'Provisionnement, publications, sauvegardes et exports en file.',
    filtreGalerie: 'Filtrer par galerie',
    colonnes: {
      type: 'Type',
      etat: 'État',
      tentatives: 'Tentatives',
      runAt: 'Prévu le',
      erreur: 'Dernière erreur',
    },
    relancer: 'Relancer',
    enCoursRelance: 'Relance…',
    succesRelance: 'Travail relancé.',
    vide: 'Aucun travail en file.',
    etatValeur: {
      en_attente: 'En attente',
      en_cours: 'En cours',
      reussi: 'Réussi',
      echoue: 'Échoué',
      abandonne: 'Abandonné',
      ignore_module_inactif: 'Ignoré, module inactif',
    },
    aucuneErreur: '—',
    etatFiltre: { actifs: 'Tous sauf les ignorés', tous: 'Tous les états' },
    typeTous: 'Tous les types',
    videFiltres: 'Aucun travail ne correspond à ces filtres.',
    pagePrecedente: 'Page précédente',
    pageSuivante: 'Page suivante',
    page: 'Page {{page}} sur {{pages}} · {{total}} travaux',
  },
  journal: {
    titre: 'Journal',
    texte: 'Toutes les actions de la console, horodatées.',
    filtreGalerie: 'Filtrer par galerie',
    colonnes: {
      date: 'Date',
      acteur: 'Acteur',
      action: 'Action',
      cible: 'Cible',
      details: 'Détail',
    },
    // Toutes les actions que l'API écrit dans `platform_audit` (`i18nJournal.ts`,
    // gardé par `lib/journal.test.ts`). Une action inconnue s'affiche quand même
    // telle quelle : le journal ne cache jamais une ligne faute de traduction.
    actions: actionsJournalFr,
    champs: champsJournalFr,
    valeurs: { oui: 'oui', non: 'non', vide: '—' },
    vide: 'Aucune entrée de journal.',
    pagePrecedente: 'Page précédente',
    pageSuivante: 'Page suivante',
    page: 'Page {{page}}',
    aucunDetail: '—',
    devient: 'devient',
  },
  interrupteurs: {
    titre: 'Interrupteurs globaux',
    texte:
      'Gérez l’accès aux modules complémentaires et aux services pour toutes les galeries. Le cœur de l’application reste toujours accessible.',
    portee:
      'Allumé : le module est autorisé pour les galeries qui l’ont activé dans leur fiche, onglet Modules. Éteint : l’accès est bloqué pour toutes les galeries, sans supprimer leurs données. La prise en compte peut prendre jusqu’à 30 secondes. Les modules à venir restent non activables.',
    resume: {
      titre: 'Résumé',
      pilotables_one: 'module pilotable',
      pilotables_other: 'modules pilotables',
      coupes_one: 'coupé globalement',
      coupes_other: 'coupés globalement',
      nonDebloques_one: 'non débloqué par son palier',
      nonDebloques_other: 'non débloqués par leur palier',
      coeur: 'dans le cœur',
    },
    coeurTitre: 'Cœur de l’application',
    coeurTexte:
      'Inclus pour toutes les galeries, sans interrupteur : ni la console ni la variable de secours ne les coupent.',
    toujoursActif: 'Toujours actif',
    pilotablesTitre: 'Modules pilotables',
    categories: {
      'ventes-clients': 'Ventes et clients',
      'oeuvres-documents': 'Œuvres et documents',
      'artistes-contrats': 'Artistes et contrats',
      diffusion: 'Diffusion et communication',
      ia: 'Intelligence artificielle',
      gestion: 'Argent et gestion',
      'equipe-integrations': 'Équipe, accès et intégrations',
    },
    service: 'Service',
    recherche: 'Rechercher un module',
    recherchePlaceholder: 'Nom ou description',
    filtreEtat: 'Filtrer par état',
    filtre: {
      tous: 'Tous',
      coupes: 'Coupés',
      verrouilles: 'Non débloqués',
      avenir: 'Bientôt disponibles',
    },
    resultats_one: '{{count}} module affiché',
    resultats_other: '{{count}} modules affichés',
    aucunResultat: 'Aucun module ne correspond.',
    refusTitre: 'Réservé à la direction de Venio',
    refusTexte:
      'Couper un module pour toutes les galeries est réservé à la direction de Venio. Contactez-la si besoin.',
    colonnes: { module: 'Module', etat: 'État', detail: 'Détail', actions: 'Actions' },
    etat: {
      ouvert: 'Accès autorisé',
      coupe: 'Accès bloqué',
      secours: 'Coupé par la variable de secours',
      palier: 'Non débloqué · {{palier}}',
    },
    palierLien: 'Voir dans Paliers',
    palierExplication:
      'Aucune galerie ne peut l’utiliser tant que son palier est verrouillé : il n’y a rien à couper.',
    palierEtCoupe:
      'Il reste aussi coupé en urgence : le rétablir ici ne le rendra accessible qu’une fois son palier débloqué.',
    detailCoupe: 'Par {{auteur}}, le {{date}}. Motif : {{motif}}',
    detailSecours: 'Se retire en redéployant.',
    bientot: 'Bientôt disponible',
    aucunDetail: '—',
    couper: 'Couper pour toutes les galeries',
    retablir: 'Rétablir',
    couperTitre: 'Couper {{module}} pour toutes les galeries ?',
    couperTexte:
      'Le module s’éteint pour toutes les galeries qui l’ont activé. Leurs données sont conservées.',
    retablirTitre: 'Rétablir {{module}} ?',
    retablirTexte: 'Le module revient pour toutes les galeries qui l’ont activé.',
    champMotif: 'Motif',
    motifAide: 'Obligatoire, trois caractères au moins. Il figure au journal.',
    erreurMotif: 'Indiquez un motif d’au moins trois caractères.',
    confirmerCoupe: 'Couper',
    confirmerRetablir: 'Rétablir',
    enCours: 'Enregistrement…',
    annuler: 'Annuler',
    fermer: 'Fermer',
    succesCoupe: '{{module}} coupé pour toutes les galeries.',
    succesRetabli: '{{module}} rétabli.',
    erreurGenerique: 'Le changement n’a pas abouti. Réessayez.',
    erreurChargement: 'Impossible de charger les interrupteurs.',
    secoursTitre: 'Variable de secours',
    secoursTexte:
      'La variable d’environnement ARTOSERA_MODULES_COUPES est lue au démarrage de l’API. Elle ne se modifie pas d’ici : pour la retirer, changez-la puis redéployez.',
    secoursAucun: 'Aucun module coupé par la variable de secours.',
  },
  paliers: {
    titre: 'Paliers',
    texte:
      'Chaque palier débloque un lot de modules pour toute la plateforme. Débloquez ou verrouillez un module, ou tout un palier d’un coup.',
    distinct:
      'Le palier est indépendant des interrupteurs d’urgence : un module débloqué ici peut encore être coupé en urgence, et inversement.',
    distinctLien: 'Ouvrir les interrupteurs globaux',
    lectureSeule:
      'Lecture seule : débloquer ou verrouiller un palier est réservé à la direction de Venio.',
    synthese: '{{debloques}} modules débloqués sur {{total}}, hors cœur',
    palier: {
      mvp: { nom: 'MVP', sousTitre: 'Le cœur, l’inventaire vivant' },
      v1: { nom: 'V1', sousTitre: 'Le bureau de la galerie' },
      v2: { nom: 'V2', sousTitre: 'Hors les murs' },
      finale: { nom: 'Version finale', sousTitre: 'Rayonnement et réseau' },
    },
    court: { mvp: 'MVP', v1: 'palier V1', v2: 'palier V2', finale: 'version finale' },
    etat: {
      inclus: 'Inclus',
      debloque: 'Débloqué',
      partiel: 'Partiel',
      verrouille: 'Verrouillé',
    },
    progression: '{{debloques}} / {{total}} débloqués',
    progressionInclus: '{{total}} / {{total}} inclus',
    progressionAria: '{{debloques}} modules débloqués sur {{total}}',
    inclusTexte:
      'Inclus pour toutes les galeries : ni verrou, ni interrupteur. Rien à décider ici.',
    inclusModule: 'Inclus',
    debloquerTout: 'Débloquer tout le palier',
    verrouillerTout: 'Verrouiller tout le palier',
    groupeAction: 'Actions du palier {{palier}}',
    listeModules: 'Modules du palier {{palier}}',
    debloquerPalierTitre: 'Débloquer tout le palier {{palier}} ?',
    debloquerPalierTexte:
      'Les {{count}} modules de ce palier deviennent disponibles pour toute la plateforme. Chaque galerie les active ensuite depuis sa fiche.',
    verrouillerPalierTitre: 'Verrouiller tout le palier {{palier}} ?',
    verrouillerPalierTexte:
      'Les {{count}} modules de ce palier ne sont plus proposés à aucune galerie. Leurs données sont conservées.',
    debloquerModuleTitre: 'Débloquer {{module}} ?',
    debloquerModuleTexte: 'Le module devient disponible pour toute la plateforme.',
    verrouillerModuleTitre: 'Verrouiller {{module}} ?',
    verrouillerModuleTexte:
      'Le module n’est plus proposé à aucune galerie. Leurs données sont conservées.',
    champMotif: 'Motif',
    motifAide: 'Obligatoire, trois caractères au moins. Il figure au journal.',
    erreurMotif: 'Indiquez un motif d’au moins trois caractères.',
    confirmerDebloquer: 'Débloquer',
    confirmerVerrouiller: 'Verrouiller',
    enCours: 'Enregistrement…',
    annuler: 'Annuler',
    fermer: 'Fermer',
    moduleDebloque: 'Débloqué',
    moduleVerrouille: 'Verrouillé',
    bientot: 'Bientôt disponible',
    dependanceFermee: 'Une dépendance est fermée : ce module reste indisponible.',
    bientotTexte: 'Pas encore livré : le déblocage ne le rend pas activable.',
    coupeUrgence: 'Coupé en urgence',
    coupeSecours: 'Coupé par la variable de secours',
    urgenceLien: 'Voir les interrupteurs globaux',
    detailModif: 'Modifié par {{auteur}}, le {{date}}. Motif : {{motif}}',
    succesModuleDebloque: '{{module}} débloqué.',
    succesModuleVerrouille: '{{module}} verrouillé.',
    succesPalierDebloque: 'Palier {{palier}} débloqué.',
    succesPalierVerrouille: 'Palier {{palier}} verrouillé.',
    conflit:
      'Quelqu’un a modifié les paliers entre-temps. La liste a été rechargée : vérifiez, puis recommencez.',
    erreurGenerique: 'Le changement n’a pas abouti. Réessayez.',
    erreurNonVerrouillable: 'Ce palier ou ce module est inclus : il ne se verrouille pas.',
    erreurIntrouvable: 'Ce module est introuvable. La liste a été rechargée.',
    erreurChargement: 'Impossible de charger les paliers.',
  },
  sante: {
    titre: 'Santé',
    texte: 'État de l’API, de la base plateforme et des connexions de galerie.',
    statut: { ok: 'Opérationnelle', degrade: 'Dégradée' },
    version: 'Version',
    environnement: 'Environnement',
    disponibiliteDepuis: 'En service depuis',
    verifieLe: 'Vérifié le {{date}}',
    plateforme: { titre: 'Base plateforme', base: 'Base', ping: 'Latence', hors: 'Injoignable' },
    galeries: {
      titre: 'Connexions de galerie',
      connexions: 'Connexions ouvertes',
      inactivite: 'Inactivité maximale',
      bases: 'Galeries connectées',
      aucune: 'Aucune connexion ouverte.',
    },
    migration: { titre: 'Dernière migration', aucune: 'Aucune migration appliquée.' },
  },
  vueDAigle: vueDAigleFr,
  comptabilite: comptabiliteFr,
  commun: {
    chargement: 'Chargement…',
    erreurReseau: 'Impossible de joindre le serveur. Réessayez.',
    tableauDefilant: 'Tableau (défile horizontalement)',
  },
};

const en: typeof fr = {
  ia: enIa,
  addons: enAddons,
  ventes: ventesEn,
  appsMobiles: enAppsMobiles,
  ...enSaisies,
  ...enOuvertures,
  ...enDemandesSite,
  ...enDemandesOuverture,
  ...enDiagnosticsIos,
  ...enReprise,
  ...enCorrespondance,
  ...enConnecteur,
  ...enImages,
  plan: enPlan,
  ...enEspaces,
  connecteurs: {
    sso: {
      resume: 'Single sign-on: {{identites}}, {{sessions}}, last sign-in {{date}}.',
      identites_one: '{{count}} linked identity',
      identites_other: '{{count}} linked identities',
      sessions_one: '{{count}} open session',
      sessions_other: '{{count}} open sessions',
      jamais: 'never',
      inactif: 'Single sign-on is disabled.',
      erreur: 'Could not read the single sign-on status.',
    },
    titre: 'Connectors',
    erreur: 'Could not read the connectors.',
    simulation: 'Platform in simulated mode: no third-party service is called.',
    reel: 'Platform in live mode.',
    colonnes: {
      connecteur: 'Connector',
      module: 'Module',
      etat: 'Status',
      secret: 'Secret',
      verifie: 'Checked on',
    },
    noms: {
      brevo: 'Brevo (newsletter)',
      artsy: 'Artsy',
      artnet: 'Artnet',
      stripe: 'Stripe (payment)',
      oidc: 'Identity provider (OIDC)',
    },
    moduleActif: 'Module enabled',
    moduleInactif: 'Module not enabled',
    modes: { simule: 'Configured (simulated)', reel: 'Configured' },
    etats: { nonConfigure: 'Not configured', erreur: 'Error: {{code}}' },
  },
  marque: {
    console: 'Artosera Console',
    titre: 'Platform operations',
    piedDePage: 'Artosera — the console',
  },
  nav: {
    aria: 'Console navigation',
    vueDAigle: 'Overview',
    comptabilite: 'Accounting',
    finances: 'Finances',
    jalons: 'Milestones',
    associes: 'Partners',
    galeries: 'Galleries',
    ouvertures: 'Onboardings',
    demandes: 'Requests',
    demandesSite: 'Website requests',
    diagnosticsIos: 'App crashes',
    profils: 'Migration profiles',
    travaux: 'Jobs',
    journal: 'Log',
    sante: 'Health',
    paliers: 'Tiers',
    appsMobiles: 'Mobile apps',
    interrupteurs: 'Global switches',
    securite: 'Security',
    ouvrirMenu: 'Open navigation',
    fermerMenu: 'Close navigation',
  },
  roles: {
    associe: 'Partner',
    support: 'Support',
    exploitation: 'Operations',
    direction: 'Direction',
    inconnu: 'Unknown role',
  },
  session: {
    verification: 'Checking session…',
    seDeconnecter: 'Sign out',
    accesRefuseTitre: 'Restricted to Venio',
    accesRefuseTexte:
      'This account has no role on the Artosera console. Contact Venio’s direction.',
    reserveDirection: 'This page is reserved for Venio’s direction.',
    pasOuverte: 'This page is not open to your role.',
    titreDocument: '{{page}} — Artosera console',
  },
  securite: {
    titre: 'Account security',
    sousTitre: 'Two-factor authentication protects access to the console.',
    confine:
      'Two-factor authentication is required for this account. Set it up to continue: the console stays closed until then.',
    grace: 'Two-factor authentication is required for this account. Set it up now.',
    statutActif: 'Two-factor authentication enabled',
    statutInactif: 'Two-factor authentication not set up',
    demarrer: 'Set up two-factor authentication',
    etape1Titre: '1. Add the account to your app',
    etape1Texte: 'Scan this code with an authenticator app (for instance the one on your phone).',
    qrAlt: 'QR code to scan with your authenticator app',
    cleManuelle: 'Or type this key by hand:',
    etape2Titre: '2. Enter the code shown',
    champCode: 'Six-digit code',
    confirmer: 'Enable',
    annuler: 'Cancel',
    codesTitre: 'Your backup codes',
    codesTexte:
      'Each code works once, if you no longer have your phone. Keep them somewhere safe: they will not be shown again.',
    codesListe: 'Backup codes',
    continuer: 'I have saved my codes, continue',
    regenererTitre: 'Backup codes',
    regenererTexte:
      'New codes replace the old ones. Enter a code from your app, never a backup code.',
    regenerer: 'Generate new codes',
    termine: 'Done',
    erreurCode: 'Code refused. Check your phone’s clock and try again.',
    erreurGenerique: 'The operation did not go through. Try again.',
  },
  connexion: {
    titre: 'Artosera Console',
    sousTitre: 'Restricted to Venio accounts.',
    champEmail: 'Email address',
    champMotDePasse: 'Password',
    bouton: 'Sign in',
    enCours: 'Signing in…',
    erreurGenerique: 'Sign-in failed. Try again.',
    erreurIdentifiants: 'Invalid credentials.',
    erreurVerrouille:
      'This account is locked after several failed attempts. Try again in a few minutes.',
    erreurDesactive: 'This account is disabled. Contact Venio’s direction.',
    titreOnglet: 'Sign in',
    deuxiemeFacteurTitre: 'Two-factor authentication',
    deuxiemeFacteurTexte: 'Enter the code from your authenticator app.',
    champCodeTotp: 'Six-digit code',
    champCodeSecours: 'Backup code',
    utiliserCodeSecours: 'Use a backup code instead',
    utiliserTotp: 'Use the app code instead',
    valider: 'Confirm',
  },
  galeries: {
    titre: 'Galleries',
    texte: 'Every gallery hosted by Artosera.',
    nouvelleGalerie: 'New gallery',
    rechercheLabel: 'Search a gallery',
    recherchePlaceholder: 'Name or id…',
    filtreEtatLabel: 'State',
    filtrePalierLabel: 'Tier',
    tousEtats: 'All states',
    tousPaliers: 'All tiers',
    etat: {
      active: 'Active',
      suspendue: 'Suspended',
      resiliee: 'Terminated',
      purge_en_cours: 'Purge in progress',
      purgee: 'Purged',
    },
    palier: { essentiel: 'Essential', galerie: 'Gallery', groupe: 'Group' },
    colonnes: {
      nom: 'Gallery',
      palier: 'Tier',
      etat: 'State',
      addons: 'Add-ons',
      modules: 'Modules',
      connecteurs: 'Connectors',
      domaines: 'Domains',
      membres: 'Members',
      dernierePublication: 'Last publish',
      derniereSauvegarde: 'Last backup',
    },
    jamais: 'Never',
    coeurSeul: 'Core only',
    vide: 'No gallery matches these filters.',
  },
  fiche: {
    retour: 'Back to galleries',
    introuvable: 'This gallery cannot be found.',
    creeLe: 'Created on {{date}}',
    onglets: {
      identite: 'Identity and tier',
      addons: 'Add-ons',
      modules: 'Modules',
      theme: 'Back-office theme',
      connecteurs: 'Connectors',
      domaines: 'Domains',
      membres: 'Members',
      sauvegardes: 'Backups and exports',
      reprise: 'Migration',
      travaux: 'Jobs',
      journal: 'Log',
      support: 'Support access',
      resiliation: 'Termination',
    },
    identite: {
      titre: 'Identity and tier',
      champPalier: 'Tier',
      champEtat: 'State',
      groupe: 'Group',
      aucunGroupe: 'No group',
      palierAide:
        'The tier is commercial data: it sets the quotas, never the modules. Set them in the Modules tab.',
      lienModules: 'Set the modules',
      quotasTitre: 'Quotas',
      stockage: 'Storage',
      stockageIndisponible: 'Not measured yet · quota {{quota}}',
      stockageMesure: '{{utilise}} of {{quota}} · {{objets}} objects · measured {{mesureLe}}',
      membresMax: 'Members allowed',
      illimite: 'Unlimited',
      enregistrer: 'Save',
      enCours: 'Saving…',
      succes: 'Record updated.',
    },
    theme: {
      titre: 'Back-office theme',
      texte:
        'The design of this gallery’s back office: navigation, typography and palette. Light or dark mode and fair mode remain each user’s choice.',
      choixClient: 'Let the client choose their theme',
      choixClientAide:
        'Off: the back office applies this theme and shows no design picker. On: each user picks their own design, and this theme stays the default.',
      lectureSeule: 'Read only: your role cannot change the theme.',
      resiliee: 'This gallery is terminated: its theme can no longer be changed.',
      enregistrer: 'Save',
      enCours: 'Saving…',
      succes: 'Back-office theme updated.',
      erreur: 'The theme could not be saved. Try again.',
      fermer: 'Close',
      descriptions: {
        halo: 'Soft surfaces, sidebar navigation and clear daily priorities.',
        structure: 'Horizontal navigation, working lists and a precise inspector.',
        collection: 'A visual inventory, contrasting header and artwork in focus.',
        brut: 'Kraft paper, signal orange, thick rules and hard shadows.',
        atelier: 'Editorial composition, a mineral palette and a sidebar workspace.',
        aurore: 'Ambient light, frosted glass and floating pill navigation.',
        monolithe: 'Space, fine rules, a champagne accent and a quiet sidebar.',
        blanc: 'Warm white walls, graphite and artwork hanging in a quiet space.',
        spatial: 'Neutral glass, soft depth and a floating sidebar rail.',
        chrome: 'Satin metal, wide typography and an iridescent horizontal selector.',
        'liquid-glass':
          'Liquid glass: floating translucent bars, edge highlights and sharp artwork up front.',
        'verre-de-jour':
          'Daylit gallery: pale glass capsules, halos drawn from the artwork and a soft mauve accent.',
        'verre-de-nuit':
          'Night glass: dark glass islands, violet glows and a floating navigation capsule.',
      },
    },
    modules: {
      titreCoeur: 'Core',
      texteCoeur: 'Always on, for every gallery. They cannot be turned off.',
      inclus: 'Included',
      titreComplementaires: 'Add-on modules',
      texteComplementaires:
        'Sold as options, off by default. Turning a module off never deletes any data.',
      titreServices: 'Services',
      texteServices:
        'The public website and the shop, sold as services. Off by default; switched off, no public route answers.',
      lectureSeule: 'Read only: your role cannot change the modules.',
      resiliee: 'This gallery is terminated: its modules can no longer be changed.',
      etat: {
        actif: 'On',
        inactif: 'Off',
        coupe: 'Switched off for every gallery',
        bientot: 'Coming soon',
        enAttente: 'Waiting for a required module',
      },
      necessite: 'Requires {{liste}}',
      dependants_one: '{{liste}} depends on it',
      dependants_other: '{{liste}} depend on it',
      activerDabord: 'Turn on {{liste}} first.',
      eteint: 'Turned on, but off while {{liste}} is missing.',
      coupeTexte:
        'Switched off for every gallery. It will come back when Venio’s direction restores it.',
      bientotTexte: 'Not delivered yet: it cannot be turned on.',
      succesActive: '{{module}} turned on.',
      succesDesactive: '{{module}} turned off. The data is kept.',
      desactiverTitre: 'Turn off {{module}}?',
      desactiverTexte:
        'The data is kept. It will all come back when the module is turned on again.',
      desactiverVentes:
        'Invoices and credit notes already issued stay available: the law requires keeping them for ten years.',
      desactiverSite:
        'Forms, sign-ups and publishing stop, and the published site is taken offline. Its pages, settings and versions are kept: turning it back on republishes it.',
      desactiverDependants: 'These modules depend on it and will turn off too: {{liste}}.',
      desactiver: 'Turn off',
      annuler: 'Cancel',
      fermer: 'Close',
      enCours: 'Saving…',
      erreurChargement: 'Could not load this gallery’s modules.',
      erreurs: {
        module_coeur: 'This module is part of the core: it cannot be turned off.',
        module_non_disponible: 'This module is not delivered yet: it cannot be turned on.',
        dependances_manquantes: 'Turn on {{liste}} first.',
        galerie_resiliee: 'This gallery is terminated: its modules can no longer be changed.',
        revision_modules_perimee:
          'This gallery’s modules changed in the meantime. Reload the page, then try again.',
        journal_indisponible:
          'The log could not be written: nothing was changed. Try again in a moment.',
        generique: 'The change did not go through. Try again.',
      },
    },
    domaines: {
      titre: 'Domains',
      hote: 'Host',
      dns: 'Record to set',
      etat: 'State',
      verifieLe: 'Verified on',
      jamaisVerifie: 'Never verified',
      verifier: 'Verify',
      retirer: 'Remove',
      principal: 'Primary',
      rendrePrincipal: 'Make primary',
      actions: 'Actions',
      servi: 'Served by Artosera',
      consigneCname: 'CNAME → {{valeur}}',
      consigneA: 'A → {{valeurs}}',
      consigneAaaa: 'AAAA → {{valeurs}}',
      consigneANonConfiguree: 'A → server address not configured: contact the operator',
      sansAaaa: 'No AAAA record',
      aidePrincipal:
        'The primary domain is the gallery’s address: its other active domains and its Artosera subdomain redirect to it.',
      ajouter: 'Add a domain',
      champHote: 'Host name',
      dialogueTitre: 'Add a domain',
      dialogueTexte:
        'The domain is added as pending. A subdomain (www…) points a CNAME to the gallery’s Artosera subdomain; a bare domain, which cannot carry a CNAME, uses the server addresses shown on the gallery page. Follow the DNS instructions on the gallery page: A for IPv4, AAAA only for the expected IPv6 addresses.',
      annuler: 'Cancel',
      fermer: 'Close',
      vide: 'No domain.',
      etatValeur: { a_verifier: 'Pending', actif: 'Active', desactive: 'Disabled' },
      retrait: {
        titre: 'Remove this domain?',
        texte:
          '{{hote}} will no longer serve the gallery or its site: visitors using it will not reach it anymore. The row stays in the list, as “Disabled”, to keep the history.',
        garder: 'Keep the domain',
        confirmer: 'Remove the domain',
        enCours: 'Removing…',
      },
      erreurs: {
        hote_invalide:
          'This host name is not valid. Use letters, digits and hyphens separated by dots, for example www.my-gallery.com.',
        sous_domaine_plateforme:
          '{{hote}} belongs to the platform: a subdomain of {{suffixe}} cannot be used as a custom domain.',
        cname_absent: '{{hote}}: no CNAME found. Expected: {{attendu}}.',
        cname_incorrect: '{{hote}}: the CNAME points elsewhere. Expected: {{attendu}}.',
        a_absent: '{{hote}}: no A record found. Expected: {{attendu}}.',
        a_incorrect:
          '{{hote}}: every A record must point to {{attendu}}; remove those left at the previous host.',
        aaaa_present:
          '{{hote}}: delete the AAAA record. The server has no IPv6: the certificate and IPv6 visitors would fail.',
        aaaa_incorrect: '{{hote}}: AAAA records must point to {{attendu}}.',
        aaaa_indetermine:
          '{{hote}}: unable to tell whether an AAAA record exists. Try again in a moment.',
        domaine_nu_non_configure:
          'Bare-domain verification is not configured on this server: contact the operator.',
        domaine_non_actif: '{{hote}}: only an active domain can become primary.',
        suffixe_public: '{{hote}} is a public suffix: no gallery can own it.',
        domaine_deja_pris: '{{hote}} is already attached to another gallery.',
        domaine_par_defaut: 'The default subdomain is set at provisioning.',
        generique: '{{hote}}: the operation did not go through. Try again.',
      },
    },
    membres: {
      titre: 'Members',
      email: 'Email',
      droits: 'Fine-grained rights',
      aucunDroit: 'None',
      droit: {
        voirPrixArtiste: 'See the artist price',
        coffreConfidentiel: 'Open the confidential vault',
        emettreFactures: 'Issue invoices',
        publierSite: 'Publish the website',
      },
      role: 'Role',
      dernierAcces: 'Last access',
      jamaisConnecte: 'Never signed in',
      vide: 'No member.',
    },
    sauvegardes: {
      titre: 'Backups',
      date: 'Date',
      taille: 'Size',
      etat: 'Result',
      vide: 'No backup recorded yet.',
      lancerTest: 'Run a test restore',
      enCoursTest: 'Starting…',
      succesTest: 'Test restore started: follow it in Jobs.',
      etatValeur: { reussie: 'Succeeded', echouee: 'Failed', en_cours: 'Running' },
      exportsTitre: 'Exports',
      demander: 'Request an export',
      enCoursExport: 'Requesting…',
      succesExport: 'Export requested: follow it in Jobs.',
      demandeLe: 'Requested on',
      pretLe: 'Stored on',
      expireLe: 'Link valid until',
      enPreparation: 'In preparation',
      videExports: 'No export requested.',
      exportEtat: 'Status',
      exportTaille: 'Size',
      exportFinal: 'final export',
      exportEmpreinte: 'SHA-256 digest',
      exportActions: 'Actions',
      exportOrigine: {
        console: 'Console',
        mensuel: 'Monthly copy',
        resiliation: 'Termination',
      },
      exportEtatValeur: {
        en_attente: 'Queued',
        en_cours: 'Running',
        verification: 'Checking the freeze',
        pret: 'Ready',
        incomplet: 'Incomplete',
        echoue: 'Failed',
        manquant: 'Archive missing',
        supprime: 'Removed',
      },
      verificationAide:
        'The archive waits for a ten-minute quiet window, to prove that nothing writes to the gallery anymore (longer if it is still written to). The email to the direction goes out afterwards.',
      lienExpire: 'Link expired',
      envoyeLe: 'Sent on {{date}}',
      telechargeLe: 'Downloaded by the gallery on {{date}}, receipt not confirmed',
      accuseLe: 'Receipt confirmed on {{date}}',
      renvoyer: 'Resend to the direction',
      renvoye: 'Archive resent to {{transmis}} direction member(s), link valid until {{date}}.',
      consoleSansAcces:
        'The console does not download archives: they go to the gallery’s direction only.',
    },
    support: {
      titre: 'Support access',
      texte:
        'No access to a gallery’s business data without its direction’s authorization, limited to 24h and logged.',
      actif: 'Access granted',
      enAttente: 'Request pending approval by the gallery’s direction',
      inactif: 'No support access in progress.',
      refusInfo:
        'Declining a request happens on the gallery’s side, not from the console. A decline stays visible in this gallery’s Log.',
      expireLe: 'Expires on {{date}}',
      champMotif: 'Reason',
      champRole: 'Requested rights',
      roles: {
        lecture: 'Read only',
        equipe: 'Team',
      },
      aideRoles: {
        lecture: 'View and troubleshoot, without changing anything.',
        equipe:
          'Build, configure and publish the website, or fix data. The direction sees this choice before granting.',
      },
      demander: 'Request access',
      enCoursDemande: 'Requesting…',
      succesDemande: 'Access requested. The gallery’s direction must grant it.',
      revoquer: 'End access',
      enCoursRevocation: 'Ending access…',
      succesRevocation: 'Support access ended.',
    },
    resiliation: {
      titre: 'Termination',
      avertissement:
        'Termination prepares a full export and sends its link to the direction. Nothing is erased by itself: the data remains recoverable for 90 days; after that, Venio direction launches the purge (database, storage, published website), once the gallery has confirmed receipt of the export; backups have a separate 90-day retention and complete erasure requires verification. A historical partial purge remains closed to recovery and previously erased data is not restored.',
      champConfirmation: 'Gallery identifier, to confirm',
      aide: 'Type “{{slug}}” to enable termination.',
      bouton: 'Terminate the gallery',
      enCours: 'Terminating…',
      succes:
        'Termination started: export in preparation. The purge will be launched by hand, in 90 days at the earliest.',
      dejaResiliee: 'This gallery is already terminated.',
      purgeTitre: 'Purge',
      resilieeLe: 'Terminated on {{date}}.',
      purgePossible: 'Purge possible from {{date}}; nothing is purged by itself.',
      accuseLe: 'Receipt of the final export confirmed on {{date}}.',
      sansAccuse: 'No direction member has confirmed receipt of the final export yet.',
      demandeeLe: 'Purge launched on {{date}} by {{par}}.',
      purgeEnCours: 'Purge in progress since {{date}}: the gallery accepts nothing any more.',
      purgeeLe:
        'Purged on {{date}}: database, storage (all versions), website and the gallery’s own backups erased.',
      effacementPrevu:
        'Complete erasure due on {{date}}, when the shared backups that still hold it expire.',
      effacementComplet: 'Complete erasure confirmed on {{date}}: no backup holds it any more.',
      purgeForcee: 'Purge launched without a confirmed receipt. Reason: {{motif}}',
      lancerTitre: 'Launch the purge',
      lancerTexte:
        'Venio direction only. The purge erases the database, storage and published website; it cannot be undone.',
      delaiEnCours: 'The 90-day period runs until {{date}}: the purge cannot be launched yet.',
      forcerTexte:
        'Without a confirmed receipt, the purge requires a written reason: it is logged and visible to the gallery.',
      champMotif: 'Written reason',
      aideMotif: 'At least fifteen characters: the gallery’s request, its reference.',
      lancerBouton: 'Launch the purge',
      reprendreBouton: 'Resume the purge',
      lancerSucces: 'Purge launched.',
      operationsEnCours_one:
        '{{count}} operation in progress on the gallery: the purge waits for it and never interrupts it.',
      operationsEnCours_other:
        '{{count}} operations in progress on the gallery: the purge waits for them and never interrupts them.',
      remiseTitre: 'Reset the counter',
      remiseTexte:
        'Only if a crash left the counter stuck: the reset is refused while a job of the gallery is running. Beware: a download still in progress will no longer be counted, and the purge that follows will cut it. The reason is logged.',
      champMotifRemise: 'Reason for the reset',
      remiseBouton: 'Reset to zero',
      remiseSucces: 'Counter reset.',
      repriseRequise:
        'Supervised resumption required: this purge started under an earlier protocol, and its check failed ({{raison}}). The barrier stays in place; nothing tells what has already been erased.',
      repriseTitre: 'Resume the purge (supervised)',
      repriseTexte:
        'Venio direction only, after checking the gallery’s actual state (database, storage, websites). Resuming records the validation in your name and completes the purge: it cannot be undone. The reason is logged.',
      champMotifReprise: 'Reason for resuming',
      repriseBouton: 'Resume the purge',
      repriseSucces: 'Purge resumed under supervision.',
      historiqueInconnu:
        'Backup store history unknown: complete erasure will not be confirmed until it is verified.',
      historiqueTitre: 'Backup store history verified',
      historiqueTexte:
        'List ALL backup stores that may have received this gallery’s data, including those no longer configured. Each will then have to be configured and checked. The reason is logged.',
      champDepots: 'Backup stores, one per line',
      aideDepots_one: '{{count}} store entered (for example s3:https://endpoint/bucket).',
      aideDepots_other: '{{count}} stores entered (for example s3:https://endpoint/bucket).',
      champMotifHistorique: 'Reason for the verification',
      historiqueBouton: 'Declare the history verified',
      historiqueSucces: 'Backup store history declared verified.',
    },
  },
  travaux: {
    titre: 'Jobs',
    texte: 'Provisioning, publishing, backups and exports in queue.',
    filtreGalerie: 'Filter by gallery',
    colonnes: {
      type: 'Type',
      etat: 'State',
      tentatives: 'Attempts',
      runAt: 'Scheduled for',
      erreur: 'Last error',
    },
    relancer: 'Retry',
    enCoursRelance: 'Retrying…',
    succesRelance: 'Job retried.',
    vide: 'No job in queue.',
    etatValeur: {
      en_attente: 'Pending',
      en_cours: 'Running',
      reussi: 'Succeeded',
      echoue: 'Failed',
      abandonne: 'Abandoned',
      ignore_module_inactif: 'Skipped, module off',
    },
    aucuneErreur: '—',
    etatFiltre: { actifs: 'All but ignored', tous: 'All states' },
    typeTous: 'All types',
    videFiltres: 'No job matches these filters.',
    pagePrecedente: 'Previous page',
    pageSuivante: 'Next page',
    page: 'Page {{page}} of {{pages}} · {{total}} jobs',
  },
  journal: {
    titre: 'Log',
    texte: 'Every console action, timestamped.',
    filtreGalerie: 'Filter by gallery',
    colonnes: {
      date: 'Date',
      acteur: 'Actor',
      action: 'Action',
      cible: 'Target',
      details: 'Detail',
    },
    actions: actionsJournalEn,
    champs: champsJournalEn,
    valeurs: { oui: 'yes', non: 'no', vide: '—' },
    vide: 'No log entry.',
    pagePrecedente: 'Previous page',
    pageSuivante: 'Next page',
    page: 'Page {{page}}',
    aucunDetail: '—',
    devient: 'becomes',
  },
  interrupteurs: {
    titre: 'Global switches',
    texte:
      'Manage access to add-on modules and services for every gallery. The application core always remains accessible.',
    portee:
      'On: the module is allowed for galleries that enabled it in their Modules tab. Off: access is blocked for every gallery without deleting their data. Changes may take up to 30 seconds. Modules that are coming soon cannot be enabled yet.',
    resume: {
      titre: 'Summary',
      pilotables_one: 'switchable module',
      pilotables_other: 'switchable modules',
      coupes_one: 'switched off globally',
      coupes_other: 'switched off globally',
      nonDebloques_one: 'not unlocked by its tier',
      nonDebloques_other: 'not unlocked by their tier',
      coeur: 'in the core',
    },
    coeurTitre: 'Application core',
    coeurTexte:
      'Included for every gallery, with no switch: neither the console nor the fallback variable can turn them off.',
    toujoursActif: 'Always on',
    pilotablesTitre: 'Switchable modules',
    categories: {
      'ventes-clients': 'Sales and clients',
      'oeuvres-documents': 'Artworks and documents',
      'artistes-contrats': 'Artists and contracts',
      diffusion: 'Outreach and communication',
      ia: 'Artificial intelligence',
      gestion: 'Money and management',
      'equipe-integrations': 'Team, access and integrations',
    },
    service: 'Service',
    recherche: 'Search for a module',
    recherchePlaceholder: 'Name or description',
    filtreEtat: 'Filter by state',
    filtre: {
      tous: 'All',
      coupes: 'Switched off',
      verrouilles: 'Not unlocked',
      avenir: 'Coming soon',
    },
    resultats_one: '{{count}} module shown',
    resultats_other: '{{count}} modules shown',
    aucunResultat: 'No module matches.',
    refusTitre: 'Restricted to Venio’s direction',
    refusTexte:
      'Switching a module off for every gallery is restricted to Venio’s direction. Contact them if needed.',
    colonnes: { module: 'Module', etat: 'State', detail: 'Detail', actions: 'Actions' },
    etat: {
      ouvert: 'Access allowed',
      coupe: 'Access blocked',
      secours: 'Switched off by the fallback variable',
      palier: 'Not unlocked · {{palier}}',
    },
    palierLien: 'See in Tiers',
    palierExplication:
      'No gallery can use it while its tier is locked: there is nothing to switch off.',
    palierEtCoupe:
      'It also remains switched off in an emergency: restoring it here only makes it reachable once its tier is unlocked.',
    detailCoupe: 'By {{auteur}}, on {{date}}. Reason: {{motif}}',
    detailSecours: 'Removed by redeploying.',
    bientot: 'Coming soon',
    aucunDetail: '—',
    couper: 'Switch off for every gallery',
    retablir: 'Restore',
    couperTitre: 'Switch {{module}} off for every gallery?',
    couperTexte: 'The module turns off for every gallery that turned it on. Their data is kept.',
    retablirTitre: 'Restore {{module}}?',
    retablirTexte: 'The module comes back for every gallery that turned it on.',
    champMotif: 'Reason',
    motifAide: 'Required, at least three characters. It is written to the log.',
    erreurMotif: 'Give a reason of at least three characters.',
    confirmerCoupe: 'Switch off',
    confirmerRetablir: 'Restore',
    enCours: 'Saving…',
    annuler: 'Cancel',
    fermer: 'Close',
    succesCoupe: '{{module}} switched off for every gallery.',
    succesRetabli: '{{module}} restored.',
    erreurGenerique: 'The change did not go through. Try again.',
    erreurChargement: 'Could not load the switches.',
    secoursTitre: 'Fallback variable',
    secoursTexte:
      'The ARTOSERA_MODULES_COUPES environment variable is read when the API starts. It cannot be changed from here: to remove it, change it and redeploy.',
    secoursAucun: 'No module switched off by the fallback variable.',
  },
  paliers: {
    titre: 'Tiers',
    texte:
      'Each tier unlocks a batch of modules for the whole platform. Unlock or lock a single module, or a whole tier at once.',
    distinct:
      'Tiers are independent from the emergency switches: a module unlocked here can still be switched off in an emergency, and the other way round.',
    distinctLien: 'Open the global switches',
    lectureSeule: 'Read-only: unlocking or locking a tier is restricted to Venio’s direction.',
    synthese: '{{debloques}} of {{total}} modules unlocked, core excluded',
    palier: {
      mvp: { nom: 'MVP', sousTitre: 'The core, the living inventory' },
      v1: { nom: 'V1', sousTitre: 'The gallery office' },
      v2: { nom: 'V2', sousTitre: 'Beyond the walls' },
      finale: { nom: 'Final release', sousTitre: 'Reach and network' },
    },
    court: { mvp: 'MVP', v1: 'tier V1', v2: 'tier V2', finale: 'final release' },
    etat: {
      inclus: 'Included',
      debloque: 'Unlocked',
      partiel: 'Partial',
      verrouille: 'Locked',
    },
    progression: '{{debloques}} / {{total}} unlocked',
    progressionInclus: '{{total}} / {{total}} included',
    progressionAria: '{{debloques}} modules unlocked out of {{total}}',
    inclusTexte: 'Included for every gallery: no lock, no switch. Nothing to decide here.',
    inclusModule: 'Included',
    debloquerTout: 'Unlock the whole tier',
    verrouillerTout: 'Lock the whole tier',
    groupeAction: 'Actions for tier {{palier}}',
    listeModules: 'Modules of tier {{palier}}',
    debloquerPalierTitre: 'Unlock the whole {{palier}} tier?',
    debloquerPalierTexte:
      'The {{count}} modules of this tier become available for the whole platform. Each gallery then enables them from its file.',
    verrouillerPalierTitre: 'Lock the whole {{palier}} tier?',
    verrouillerPalierTexte:
      'The {{count}} modules of this tier are no longer offered to any gallery. Their data is kept.',
    debloquerModuleTitre: 'Unlock {{module}}?',
    debloquerModuleTexte: 'The module becomes available for the whole platform.',
    verrouillerModuleTitre: 'Lock {{module}}?',
    verrouillerModuleTexte: 'The module is no longer offered to any gallery. Their data is kept.',
    champMotif: 'Reason',
    motifAide: 'Required, at least three characters. It goes in the log.',
    erreurMotif: 'Enter a reason of at least three characters.',
    confirmerDebloquer: 'Unlock',
    confirmerVerrouiller: 'Lock',
    enCours: 'Saving…',
    annuler: 'Cancel',
    fermer: 'Close',
    moduleDebloque: 'Unlocked',
    moduleVerrouille: 'Locked',
    bientot: 'Coming soon',
    dependanceFermee: 'A dependency is closed: this module remains unavailable.',
    bientotTexte: 'Not delivered yet: unlocking it does not make it enableable.',
    coupeUrgence: 'Switched off in an emergency',
    coupeSecours: 'Switched off by the fallback variable',
    urgenceLien: 'See the global switches',
    detailModif: 'Changed by {{auteur}}, on {{date}}. Reason: {{motif}}',
    succesModuleDebloque: '{{module}} unlocked.',
    succesModuleVerrouille: '{{module}} locked.',
    succesPalierDebloque: 'Tier {{palier}} unlocked.',
    succesPalierVerrouille: 'Tier {{palier}} locked.',
    conflit:
      'Someone changed the tiers in the meantime. The list was reloaded: check it, then try again.',
    erreurGenerique: 'The change did not go through. Try again.',
    erreurNonVerrouillable: 'This tier or module is included: it cannot be locked.',
    erreurIntrouvable: 'This module was not found. The list was reloaded.',
    erreurChargement: 'Unable to load the tiers.',
  },
  sante: {
    titre: 'Health',
    texte: 'State of the API, the platform database and gallery connections.',
    statut: { ok: 'Operational', degrade: 'Degraded' },
    version: 'Version',
    environnement: 'Environment',
    disponibiliteDepuis: 'Up since',
    verifieLe: 'Checked on {{date}}',
    plateforme: {
      titre: 'Platform database',
      base: 'Database',
      ping: 'Latency',
      hors: 'Unreachable',
    },
    galeries: {
      titre: 'Gallery connections',
      connexions: 'Open connections',
      inactivite: 'Maximum idle time',
      bases: 'Connected galleries',
      aucune: 'No open connection.',
    },
    migration: { titre: 'Last migration', aucune: 'No migration applied.' },
  },
  vueDAigle: vueDAigleEn,
  comptabilite: comptabiliteEn,
  commun: {
    chargement: 'Loading…',
    erreurReseau: 'Could not reach the server. Try again.',
    tableauDefilant: 'Table (scrolls horizontally)',
  },
};

export const resources = { fr: { console: fr }, en: { console: en } } as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: 'fr',
  fallbackLng: 'fr',
  defaultNS: 'console',
  ns: ['console'],
  interpolation: { escapeValue: false },
});

export default i18n;
